(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["agreement-check"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function(event) {
  const targetButton = document.querySelector('.checkout__button');
  const agree = document.querySelector('input[name="kiwabi-agree"]');
  targetButton.disabled = true;
  agree.addEventListener('click', () => {
    if(agree.checked){
      targetButton.disabled = false;
    } else {
      targetButton.disabled = true;
    }
  });
}, false);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiwabi-rb-media-swipe"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var states = new Set();
  var sequence = 0;
  function youtubeReady() {
    if (window.YT && typeof window.YT.Player === 'function') return Promise.resolve(window.YT);
    if (window.__rbcYouTubeReady) return window.__rbcYouTubeReady;
    window.__rbcYouTubeReady = new Promise(function (resolve) {
      var done = false, previous = window.onYouTubeIframeAPIReady;
      function finish(api) { if (!done) { done = true; resolve(api); } }
      window.onYouTubeIframeAPIReady = function () {
        try { if (typeof previous === 'function') previous(); } catch (error) {}
        finish(window.YT || null);
      };
      if (!document.querySelector('script[src*="youtube.com/iframe_api"],script[src*="youtube.com/player_api"]')) {
        var script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api'; script.async = true;
        script.onerror = function () { finish(null); }; document.head.appendChild(script);
      }
      window.setTimeout(function () { finish(window.YT || null); }, 15000);
    });
    return window.__rbcYouTubeReady;
  }
  function plainText(element) {
    if (!element) return '';
    var copy = element.cloneNode(true);
    copy.querySelectorAll('script,style,iframe,button').forEach(function (node) { node.remove(); });
    copy.querySelectorAll('br').forEach(function (node) { node.replaceWith(document.createTextNode('\n')); });
    copy.querySelectorAll('p').forEach(function (node) { node.appendChild(document.createTextNode('\n')); });
    return copy.textContent.trim();
  }
  function fillReviews(root) {
    var source = root.querySelector('template[data-rbc-review-source]'), list = root.querySelector('[data-rbc-review-list]');
    if (!source || !list) return;
    var fragment = document.createDocumentFragment(), seen = new Set(), count = 0;
    source.content.querySelectorAll('.jdgm-rev[data-review-id]').forEach(function (review) {
      if (count >= 5) return;
      var id = review.getAttribute('data-review-id'), productUrl = review.getAttribute('data-product-url');
      if (!id || seen.has(id)) return;
      if (productUrl) {
        try { if (new URL(productUrl, document.baseURI).pathname.split('/').filter(Boolean).pop() !== root.dataset.productHandle) return; }
        catch (error) { return; }
      }
      var body = plainText(review.querySelector('.jdgm-rev__body'));
      var title = plainText(review.querySelector('.jdgm-rev__title'));
      var scoreNode = review.querySelector('.jdgm-rev__rating'), score = Number(scoreNode && scoreNode.getAttribute('data-score'));
      if (!body || !Number.isFinite(score) || score < 1 || score > 5) return;
      seen.add(id);
      var item = document.createElement('article'); item.className = 'rbc-media-review-item'; item.dataset.reviewId = id;
      var meta = document.createElement('div'); meta.className = 'rbc-media-review-meta';
      var stars = document.createElement('span'); stars.className = 'rbc-media-review-stars'; stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', '5点満点中' + score + '点');
      stars.textContent = '★'.repeat(Math.round(score)) + '☆'.repeat(5 - Math.round(score)); meta.appendChild(stars);
      var dateNode = review.querySelector('.jdgm-rev__timestamp'), date = dateNode && dateNode.getAttribute('datetime');
      if (date && /^\d{4}-\d{2}-\d{2}/.test(date)) {
        var time = document.createElement('time'); time.dateTime = date; time.textContent = date.slice(0, 10).replace(/-/g, '.'); meta.appendChild(time);
      }
      item.appendChild(meta);
      if (title) { var heading = document.createElement('h4'); heading.textContent = title; item.appendChild(heading); }
      var paragraph = document.createElement('p'); paragraph.className = 'rbc-media-review-body'; paragraph.textContent = body; item.appendChild(paragraph);
      fragment.appendChild(item); count++;
    });
    if (count) {
      list.replaceChildren(fragment); list.setAttribute('aria-label', count + '件の公開レビュー。上下にスクロールして読めます。');
      var hint = root.querySelector('[data-rbc-review-hint]'); if (hint) hint.textContent = count + '件・下へスクロール ↓';
      root.dataset.rbcVisibleReviews = String(count);
    }
  }
  function pauseOthers(active) { states.forEach(function (state) { if (state !== active) state.pause(); }); }
  function prepare(root) {
    if (root.dataset.rbcReady === 'v1') return;
    var track = root.querySelector('[data-rbc-track]'), slides = Array.from(root.querySelectorAll('[data-rbc-slide]'));
    var buttons = Array.from(root.querySelectorAll('[data-rbc-go]'));
    if (!track || !slides.length || (slides.length > 1 && buttons.length !== slides.length)) return;
    root.dataset.rbcReady = 'v1'; fillReviews(root);
    var frame = root.querySelector('iframe[data-rbc-video-src]'), nativeVideo = root.querySelector('video');
    var videoIndex = slides.findIndex(function (slide) { return slide.classList.contains('rbc-media-slide--video'); });
    var current = 0, player = null, requested = false, observer = null, destroyed = false, scheduled = false;
    var cleanup = [];
    function listen(element, type, callback, options) { element.addEventListener(type, callback, options); cleanup.push(function () { element.removeEventListener(type, callback, options); }); }
    function pause() {
      if (nativeVideo) { try { nativeVideo.pause(); } catch (error) {} }
      if (player && typeof player.pauseVideo === 'function') { try { player.pauseVideo(); } catch (error) {} }
      else if (frame && frame.getAttribute('src') && frame.contentWindow) {
        try { frame.contentWindow.postMessage(JSON.stringify(frame.dataset.rbcVideoHost === 'vimeo' ? {method:'pause'} : {event:'command',func:'pauseVideo',args:[]}), new URL(frame.src).origin); } catch (error) {}
      }
    }
    function loadVideo() {
      if (!track.clientWidth || current !== videoIndex || !frame || destroyed) return;
      if (!frame.getAttribute('src')) {
        try {
          var url = new URL(frame.dataset.rbcVideoSrc, document.baseURI);
          if (url.protocol !== 'https:' || !['www.youtube.com','www.youtube-nocookie.com','player.vimeo.com'].includes(url.hostname)) return;
          url.searchParams.set('autoplay', '0'); url.searchParams.set('playsinline', '1');
          if (frame.dataset.rbcVideoHost === 'youtube') { url.searchParams.set('enablejsapi', '1'); url.searchParams.set('origin', window.location.origin); }
          frame.id = 'rbc-product-video-' + (++sequence); frame.src = url.href;
        } catch (error) { return; }
      }
      if (frame.dataset.rbcVideoHost === 'youtube' && !requested) {
        requested = true;
        youtubeReady().then(function (api) {
          if (destroyed || !root.isConnected || !api || typeof api.Player !== 'function') return;
          try { player = new api.Player(frame, {events: {
            onReady:function () { if (!track.clientWidth || current !== videoIndex) pause(); },
            onStateChange:function (event) { if (event.data === 1) { if (!track.clientWidth || current !== videoIndex || document.hidden) pause(); else pauseOthers(state); } }
          }}); } catch (error) { player = null; }
        });
      }
    }
    function select(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      if (index !== current) { pause(); current = index; if (current === videoIndex) pauseOthers(state); }
      slides.forEach(function (slide, i) { var active = i === current; slide.setAttribute('aria-hidden', active ? 'false' : 'true'); if ('inert' in slide) slide.inert = !active; });
      buttons.forEach(function (button, i) { button.classList.toggle('is-active', i === current); button.setAttribute('aria-pressed', i === current ? 'true' : 'false'); });
      loadVideo();
    }
    function go(index) { select(index); track.scrollTo({left: index * track.clientWidth, behavior: 'auto'}); }
    function onScroll() { if (!scheduled) { scheduled = true; window.requestAnimationFrame(function () { scheduled = false; if (!destroyed && track.clientWidth) select(Math.round(track.scrollLeft / track.clientWidth)); }); } }
    listen(track, 'scroll', onScroll, {passive:true});
    buttons.forEach(function (button) { listen(button, 'click', function () { var index = Number(button.dataset.rbcGo); if (Number.isInteger(index) && slides[index]) go(index); }); });
    var navigation = root.querySelector('.rbc-media-pages');
    if (navigation) listen(navigation, 'keydown', function (event) {
      var focused = buttons.indexOf(event.target), target = focused; if (focused < 0) return;
      if (event.key === 'ArrowRight') target = (focused + 1) % buttons.length;
      else if (event.key === 'ArrowLeft') target = (focused + buttons.length - 1) % buttons.length;
      else if (event.key === 'Home') target = 0; else if (event.key === 'End') target = buttons.length - 1; else return;
      event.preventDefault(); buttons[target].focus({preventScroll:true}); buttons[target].click();
    });
    var state = {root:root,pause:pause,resize:function () { if (!track.clientWidth) pause(); else go(current); },destroy:function () {
      destroyed = true; pause(); if (observer) observer.disconnect(); cleanup.forEach(function (fn) { fn(); });
      if (player && player.destroy) { try { player.destroy(); } catch (error) {} } states.delete(state); delete root.dataset.rbcReady;
    }};
    states.add(state);
    if (nativeVideo) listen(nativeVideo, 'play', function () { if (current !== videoIndex || document.hidden) pause(); else pauseOthers(state); });
    var videoSurface = root.querySelector('.rbc-media-player');
    if (videoSurface && 'IntersectionObserver' in window) { observer = new IntersectionObserver(function (entries) { if (entries[0] && entries[0].intersectionRatio < 0.15) pause(); }, {threshold:[0,0.15]}); observer.observe(videoSurface); }
    select(0);
  }
  function initialize() {
    states.forEach(function (state) { if (!state.root.isConnected) state.destroy(); });
    document.querySelectorAll('#rb-comparison [data-rbc-carousel]').forEach(prepare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', function (event) { states.forEach(function (state) { if (event.target.contains(state.root)) state.destroy(); }); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) pauseOthers(null); });
  window.addEventListener('pagehide', function () { pauseOthers(null); });
  window.addEventListener('resize', function () { states.forEach(function (state) { state.resize(); }); }, {passive:true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiwabi-rv-base-before-latest-20261012"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var states = new Set();
  var idSequence = 0;

  function youtubeReady() {
    if (window.YT && typeof window.YT.Player === 'function') return Promise.resolve(window.YT);
    if (window.__rvcYouTubeReady) return window.__rvcYouTubeReady;
    window.__rvcYouTubeReady = new Promise(function (resolve) {
      var done = false;
      var previous = window.onYouTubeIframeAPIReady;
      function finish(api) { if (!done) { done = true; resolve(api); } }
      window.onYouTubeIframeAPIReady = function () {
        try { if (typeof previous === 'function') previous(); } catch (error) {}
        finish(window.YT || null);
      };
      if (!document.querySelector('script[src*="youtube.com/iframe_api"],script[src*="youtube.com/player_api"]')) {
        var script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.onerror = function () { finish(null); };
        document.head.appendChild(script);
      }
      window.setTimeout(function () { finish(window.YT || null); }, 15000);
    });
    return window.__rvcYouTubeReady;
  }

  function plainText(element) {
    if (!element) return '';
    var copy = element.cloneNode(true);
    copy.querySelectorAll('script,style,iframe,button').forEach(function (node) { node.remove(); });
    copy.querySelectorAll('br').forEach(function (node) { node.replaceWith(document.createTextNode('\n')); });
    copy.querySelectorAll('p').forEach(function (node) { node.appendChild(document.createTextNode('\n')); });
    return copy.textContent.trim();
  }

  function fillReviews(card) {
    var source = card.querySelector('template[data-rvc-review-source]');
    var list = card.querySelector('[data-rvc-review-list]');
    if (!source || !list) return;
    var fragment = document.createDocumentFragment();
    var seen = new Set();
    var count = 0;
    source.content.querySelectorAll('.jdgm-rev[data-review-id]').forEach(function (review) {
      if (count >= 5) return;
      var id = review.getAttribute('data-review-id');
      if (!id || seen.has(id)) return;
      var productUrl = review.getAttribute('data-product-url');
      if (productUrl) {
        try {
          var handle = new URL(productUrl, window.location.origin).pathname.split('/').filter(Boolean).pop();
          if (handle !== card.dataset.productHandle) return;
        } catch (error) { return; }
      }
      var body = plainText(review.querySelector('.jdgm-rev__body'));
      var title = plainText(review.querySelector('.jdgm-rev__title'));
      var scoreNode = review.querySelector('.jdgm-rev__rating');
      var score = Number(scoreNode && scoreNode.getAttribute('data-score'));
      if (!body || !Number.isFinite(score) || score < 1 || score > 5) return;
      seen.add(id);
      var item = document.createElement('article');
      item.className = 'rvc-mob-review-item';
      item.dataset.reviewId = id;
      var meta = document.createElement('div');
      meta.className = 'rvc-mob-review-meta';
      var stars = document.createElement('span');
      stars.className = 'rvc-mob-review-stars';
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', '5点満点中' + score + '点');
      stars.textContent = '★'.repeat(Math.round(score)) + '☆'.repeat(5 - Math.round(score));
      meta.appendChild(stars);
      var dateNode = review.querySelector('.jdgm-rev__timestamp');
      var date = dateNode && dateNode.getAttribute('datetime');
      if (date && /^\d{4}-\d{2}-\d{2}/.test(date)) {
        var time = document.createElement('time');
        time.dateTime = date;
        time.textContent = date.slice(0, 10).replace(/-/g, '.');
        meta.appendChild(time);
      }
      item.appendChild(meta);
      if (title) { var heading = document.createElement('h4'); heading.textContent = title; item.appendChild(heading); }
      var paragraph = document.createElement('p');
      paragraph.className = 'rvc-mob-review-body';
      paragraph.textContent = body;
      item.appendChild(paragraph);
      fragment.appendChild(item);
      count += 1;
    });
    if (count) {
      list.replaceChildren(fragment);
      list.setAttribute('aria-label', count + '件の公開レビュー。上下にスクロールして読めます。');
      var hint = card.querySelector('[data-rvc-review-hint]');
      if (hint) hint.textContent = count + '件・下へスクロール ↓';
      card.dataset.rvcVisibleReviews = String(count);
    }
  }

  function pauseOthers(active) {
    states.forEach(function (state) { if (state !== active) state.pause(); });
  }

  function prepare(card) {
    if (card.dataset.rvcSwipeReady === 'v3') return;
    var track = card.querySelector('[data-rvc-track]');
    var slides = Array.from(card.querySelectorAll('[data-rvc-slide]'));
    var buttons = Array.from(card.querySelectorAll('[data-rvc-go]'));
    if (!track || slides.length < 2 || buttons.length !== slides.length) return;
    var frame = card.querySelector('iframe[data-rvc-video-src]');
    var nativeVideo = card.querySelector('video');
    var videoIndex = slides.findIndex(function (slide) { return slide.classList.contains('rvc-mob-slide--video'); });
    var current = 0;
    var player = null;
    var observer = null;
    var playerRequested = false;
    var scheduled = false;
    var destroyed = false;
    card.dataset.rvcSwipeReady = 'v3';
    fillReviews(card);
    if (card.dataset.productHandle === 'rv002' && nativeVideo) {
      var rv002Tag = card.querySelector('[data-rvc-rv002-step]');
      var rv002Text = card.querySelector('[data-rvc-rv002-text]');
      var rv002Steps = [
        ['STEP 01 / PREPARE', 'シャンプー後、タオルドライ'],
        ['STEP 02 / APPLY', '白髪が気になる部分になじませる'],
        ['STEP 03 / WAIT', '10〜15分を目安に置く'],
        ['STEP 04 / RINSE', 'よくすすいで、乾かす']
      ];
      var lastRv002Step = -1;
      var rv002UpdateText = function () {
        if (!rv002Tag || !rv002Text) return;
        var duration = Number.isFinite(nativeVideo.duration) && nativeVideo.duration > 0 ? nativeVideo.duration : 44;
        var progress = Math.max(0, Math.min(.999, nativeVideo.currentTime / duration));
        var step = Math.min(rv002Steps.length - 1, Math.floor(progress * rv002Steps.length));
        if (step === lastRv002Step) return;
        lastRv002Step = step;
        rv002Tag.textContent = rv002Steps[step][0];
        rv002Text.textContent = rv002Steps[step][1];
      };
      ['loadedmetadata','timeupdate','seeked','ended'].forEach(function (name) {
        nativeVideo.addEventListener(name, rv002UpdateText);
      });
      rv002UpdateText();
    }

    function pause() {
      if (nativeVideo) { try { nativeVideo.pause(); } catch (error) {} }
      if (frame && frame.dataset.rvcVideoHost === 'drive' && frame.getAttribute('src')) {
        frame.removeAttribute('src');
      }
      if (player && typeof player.pauseVideo === 'function') {
        try { player.pauseVideo(); } catch (error) {}
      } else if (frame && frame.getAttribute('src') && frame.contentWindow) {
        try {
          var origin = new URL(frame.src).origin;
          var command = frame.dataset.rvcVideoHost === 'vimeo' ? {method: 'pause'} : {event: 'command', func: 'pauseVideo', args: []};
          frame.contentWindow.postMessage(JSON.stringify(command), origin);
        } catch (error) {}
      }
    }

    function loadVideo() {
      if (!track.clientWidth || current !== videoIndex || !frame || destroyed) return;
      if (!frame.getAttribute('src')) {
        try {
          var url = new URL(frame.dataset.rvcVideoSrc, window.location.origin);
          if (url.protocol !== 'https:' || !['www.youtube.com','www.youtube-nocookie.com','player.vimeo.com','drive.google.com'].includes(url.hostname)) return;
          if (url.hostname !== 'drive.google.com') {
            url.searchParams.set('autoplay', '0');
            url.searchParams.set('playsinline', '1');
          }
          if (frame.dataset.rvcVideoHost === 'youtube') {
            url.searchParams.set('enablejsapi', '1');
            url.searchParams.set('origin', window.location.origin);
          }
          frame.id = 'rvc-product-video-' + (++idSequence);
          frame.src = url.href;
        } catch (error) { return; }
      }
      if (frame.dataset.rvcVideoHost === 'youtube' && !playerRequested) {
        playerRequested = true;
        youtubeReady().then(function (api) {
          if (destroyed || !card.isConnected || !api || typeof api.Player !== 'function') return;
          try {
            player = new api.Player(frame, {events: {
              onReady: function () { if (!track.clientWidth || current !== videoIndex) pause(); },
              onStateChange: function (event) {
                if (event.data === 1) {
                  if (!track.clientWidth || current !== videoIndex || document.hidden) pause();
                  else pauseOthers(state);
                }
              }
            }});
          } catch (error) { player = null; }
        });
      }
    }

    function select(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      if (index !== current) {
        pause();
        current = index;
        if (current === videoIndex) pauseOthers(state);
      }
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !active;
      });
      buttons.forEach(function (button, i) {
        button.classList.toggle('is-active', i === current);
        button.setAttribute('aria-pressed', i === current ? 'true' : 'false');
      });
      loadVideo();
    }
    function sync() {
      scheduled = false;
      if (track.clientWidth) select(Math.round(track.scrollLeft / track.clientWidth));
    }
    function scrollHandler() {
      if (!scheduled) { scheduled = true; window.requestAnimationFrame(sync); }
    }
    track.addEventListener('scroll', scrollHandler, {passive: true});
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = Number(button.dataset.rvcGo);
        if (!Number.isInteger(index) || !slides[index]) return;
        select(index);
        track.scrollTo({left: index * track.clientWidth, behavior: 'auto'});
      });
    });
    var navigation = card.querySelector('.rvc-mob-pagination');
    function keyHandler(event) {
      var focused = buttons.indexOf(event.target);
      if (focused < 0) return;
      var target = focused;
      if (event.key === 'ArrowRight') target = (focused + 1) % buttons.length;
      else if (event.key === 'ArrowLeft') target = (focused + buttons.length - 1) % buttons.length;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = buttons.length - 1;
      else return;
      event.preventDefault();
      buttons[target].focus({preventScroll: true});
      buttons[target].click();
    }
    if (navigation) navigation.addEventListener('keydown', keyHandler);
    var state = {
      card: card,
      pause: pause,
      resize: function () {
        if (!track.clientWidth) pause();
        else if (track.clientWidth) { track.scrollTo({left: current * track.clientWidth, behavior: 'auto'}); select(current); }
      },
      destroy: function () {
        destroyed = true; pause();
        if (observer) observer.disconnect();
        if (player && player.destroy) { try { player.destroy(); } catch (error) {} }
        track.removeEventListener('scroll', scrollHandler);
        if (navigation) navigation.removeEventListener('keydown', keyHandler);
        states.delete(state);
      }
    };
    states.add(state);
    if (nativeVideo) nativeVideo.addEventListener('play', function () { pauseOthers(state); });
    var videoSurface = card.querySelector('.rvc-mob-video-player');
    if (videoSurface && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].intersectionRatio < 0.15) pause();
      }, {threshold: [0, 0.15]});
      observer.observe(videoSurface);
    }
    select(0);
  }

  function initialize() {
    states.forEach(function (state) { if (!state.card.isConnected) state.destroy(); });
    document.querySelectorAll('#rv-comparison [data-rvc-mobile-card]').forEach(prepare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', function (event) {
    states.forEach(function (state) { if (event.target.contains(state.card)) state.destroy(); });
  });
  document.addEventListener('visibilitychange', function () { if (document.hidden) pauseOthers(null); });
  window.addEventListener('pagehide', function () { pauseOthers(null); });
  window.addEventListener('resize', function () { states.forEach(function (state) { state.resize(); }); }, {passive: true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiwabi-rv-media-base-20261012"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var states = new Set();
  var idSequence = 0;

  function youtubeReady() {
    if (window.YT && typeof window.YT.Player === 'function') return Promise.resolve(window.YT);
    if (window.__rvcYouTubeReady) return window.__rvcYouTubeReady;
    window.__rvcYouTubeReady = new Promise(function (resolve) {
      var done = false;
      var previous = window.onYouTubeIframeAPIReady;
      function finish(api) { if (!done) { done = true; resolve(api); } }
      window.onYouTubeIframeAPIReady = function () {
        try { if (typeof previous === 'function') previous(); } catch (error) {}
        finish(window.YT || null);
      };
      if (!document.querySelector('script[src*="youtube.com/iframe_api"],script[src*="youtube.com/player_api"]')) {
        var script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.onerror = function () { finish(null); };
        document.head.appendChild(script);
      }
      window.setTimeout(function () { finish(window.YT || null); }, 15000);
    });
    return window.__rvcYouTubeReady;
  }

  function plainText(element) {
    if (!element) return '';
    var copy = element.cloneNode(true);
    copy.querySelectorAll('script,style,iframe,button').forEach(function (node) { node.remove(); });
    copy.querySelectorAll('br').forEach(function (node) { node.replaceWith(document.createTextNode('\n')); });
    copy.querySelectorAll('p').forEach(function (node) { node.appendChild(document.createTextNode('\n')); });
    return copy.textContent.trim();
  }

  function fillReviews(card) {
    var source = card.querySelector('template[data-rvc-review-source]');
    var list = card.querySelector('[data-rvc-review-list]');
    if (!source || !list) return;
    var fragment = document.createDocumentFragment();
    var seen = new Set();
    var count = 0;
    source.content.querySelectorAll('.jdgm-rev[data-review-id]').forEach(function (review) {
      if (count >= 5) return;
      var id = review.getAttribute('data-review-id');
      if (!id || seen.has(id)) return;
      var productUrl = review.getAttribute('data-product-url');
      if (productUrl) {
        try {
          var handle = new URL(productUrl, window.location.origin).pathname.split('/').filter(Boolean).pop();
          if (handle !== card.dataset.productHandle) return;
        } catch (error) { return; }
      }
      var body = plainText(review.querySelector('.jdgm-rev__body'));
      var title = plainText(review.querySelector('.jdgm-rev__title'));
      var scoreNode = review.querySelector('.jdgm-rev__rating');
      var score = Number(scoreNode && scoreNode.getAttribute('data-score'));
      if (!body || !Number.isFinite(score) || score < 1 || score > 5) return;
      seen.add(id);
      var item = document.createElement('article');
      item.className = 'rvc-mob-review-item';
      item.dataset.reviewId = id;
      var meta = document.createElement('div');
      meta.className = 'rvc-mob-review-meta';
      var stars = document.createElement('span');
      stars.className = 'rvc-mob-review-stars';
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', '5点満点中' + score + '点');
      stars.textContent = '★'.repeat(Math.round(score)) + '☆'.repeat(5 - Math.round(score));
      meta.appendChild(stars);
      var dateNode = review.querySelector('.jdgm-rev__timestamp');
      var date = dateNode && dateNode.getAttribute('datetime');
      if (date && /^\d{4}-\d{2}-\d{2}/.test(date)) {
        var time = document.createElement('time');
        time.dateTime = date;
        time.textContent = date.slice(0, 10).replace(/-/g, '.');
        meta.appendChild(time);
      }
      item.appendChild(meta);
      if (title) { var heading = document.createElement('h4'); heading.textContent = title; item.appendChild(heading); }
      var paragraph = document.createElement('p');
      paragraph.className = 'rvc-mob-review-body';
      paragraph.textContent = body;
      item.appendChild(paragraph);
      fragment.appendChild(item);
      count += 1;
    });
    if (count) {
      list.replaceChildren(fragment);
      list.setAttribute('aria-label', count + '件の公開レビュー。上下にスクロールして読めます。');
      var hint = card.querySelector('[data-rvc-review-hint]');
      if (hint) hint.textContent = count + '件・下へスクロール ↓';
      card.dataset.rvcVisibleReviews = String(count);
    }
  }

  function pauseOthers(active) {
    states.forEach(function (state) { if (state !== active) state.pause(); });
  }

  function prepare(card) {
    if (card.dataset.rvcSwipeReady === 'v3') return;
    var track = card.querySelector('[data-rvc-track]');
    var slides = Array.from(card.querySelectorAll('[data-rvc-slide]'));
    var buttons = Array.from(card.querySelectorAll('[data-rvc-go]'));
    if (!track || slides.length < 2 || buttons.length !== slides.length) return;
    var frame = card.querySelector('iframe[data-rvc-video-src]');
    var nativeVideo = card.querySelector('video');
    var videoIndex = slides.findIndex(function (slide) { return slide.classList.contains('rvc-mob-slide--video'); });
    var current = 0;
    var player = null;
    var observer = null;
    var playerRequested = false;
    var scheduled = false;
    var destroyed = false;
    card.dataset.rvcSwipeReady = 'v3';
    fillReviews(card);

    function pause() {
      if (nativeVideo) { try { nativeVideo.pause(); } catch (error) {} }
      if (player && typeof player.pauseVideo === 'function') {
        try { player.pauseVideo(); } catch (error) {}
      } else if (frame && frame.getAttribute('src') && frame.contentWindow) {
        try {
          var origin = new URL(frame.src).origin;
          var command = frame.dataset.rvcVideoHost === 'vimeo' ? {method: 'pause'} : {event: 'command', func: 'pauseVideo', args: []};
          frame.contentWindow.postMessage(JSON.stringify(command), origin);
        } catch (error) {}
      }
    }

    function loadVideo() {
      if (!track.clientWidth || current !== videoIndex || !frame || destroyed) return;
      if (!frame.getAttribute('src')) {
        try {
          var url = new URL(frame.dataset.rvcVideoSrc, window.location.origin);
          if (url.protocol !== 'https:' || !['www.youtube.com','www.youtube-nocookie.com','player.vimeo.com'].includes(url.hostname)) return;
          url.searchParams.set('autoplay', '0');
          url.searchParams.set('playsinline', '1');
          if (frame.dataset.rvcVideoHost === 'youtube') {
            url.searchParams.set('enablejsapi', '1');
            url.searchParams.set('origin', window.location.origin);
          }
          frame.id = 'rvc-product-video-' + (++idSequence);
          frame.src = url.href;
        } catch (error) { return; }
      }
      if (frame.dataset.rvcVideoHost === 'youtube' && !playerRequested) {
        playerRequested = true;
        youtubeReady().then(function (api) {
          if (destroyed || !card.isConnected || !api || typeof api.Player !== 'function') return;
          try {
            player = new api.Player(frame, {events: {
              onReady: function () { if (!track.clientWidth || current !== videoIndex) pause(); },
              onStateChange: function (event) {
                if (event.data === 1) {
                  if (!track.clientWidth || current !== videoIndex || document.hidden) pause();
                  else pauseOthers(state);
                }
              }
            }});
          } catch (error) { player = null; }
        });
      }
    }

    function select(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      if (index !== current) {
        pause();
        current = index;
        if (current === videoIndex) pauseOthers(state);
      }
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !active;
      });
      buttons.forEach(function (button, i) {
        button.classList.toggle('is-active', i === current);
        button.setAttribute('aria-pressed', i === current ? 'true' : 'false');
      });
      loadVideo();
    }
    function sync() {
      scheduled = false;
      if (track.clientWidth) select(Math.round(track.scrollLeft / track.clientWidth));
    }
    function scrollHandler() {
      if (!scheduled) { scheduled = true; window.requestAnimationFrame(sync); }
    }
    track.addEventListener('scroll', scrollHandler, {passive: true});
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = Number(button.dataset.rvcGo);
        if (!Number.isInteger(index) || !slides[index]) return;
        select(index);
        track.scrollTo({left: index * track.clientWidth, behavior: 'auto'});
      });
    });
    var navigation = card.querySelector('.rvc-mob-pagination');
    function keyHandler(event) {
      var focused = buttons.indexOf(event.target);
      if (focused < 0) return;
      var target = focused;
      if (event.key === 'ArrowRight') target = (focused + 1) % buttons.length;
      else if (event.key === 'ArrowLeft') target = (focused + buttons.length - 1) % buttons.length;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = buttons.length - 1;
      else return;
      event.preventDefault();
      buttons[target].focus({preventScroll: true});
      buttons[target].click();
    }
    if (navigation) navigation.addEventListener('keydown', keyHandler);
    var state = {
      card: card,
      pause: pause,
      resize: function () {
        if (!track.clientWidth) pause();
        else if (track.clientWidth) { track.scrollTo({left: current * track.clientWidth, behavior: 'auto'}); select(current); }
      },
      destroy: function () {
        destroyed = true; pause();
        if (observer) observer.disconnect();
        if (player && player.destroy) { try { player.destroy(); } catch (error) {} }
        track.removeEventListener('scroll', scrollHandler);
        if (navigation) navigation.removeEventListener('keydown', keyHandler);
        states.delete(state);
      }
    };
    states.add(state);
    if (nativeVideo) nativeVideo.addEventListener('play', function () { pauseOthers(state); });
    var videoSurface = card.querySelector('.rvc-mob-video-player');
    if (videoSurface && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].intersectionRatio < 0.15) pause();
      }, {threshold: [0, 0.15]});
      observer.observe(videoSurface);
    }
    select(0);
  }

  function initialize() {
    states.forEach(function (state) { if (!state.card.isConnected) state.destroy(); });
    document.querySelectorAll('#rv-comparison [data-rvc-mobile-card]').forEach(prepare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', function (event) {
    states.forEach(function (state) { if (event.target.contains(state.card)) state.destroy(); });
  });
  document.addEventListener('visibilitychange', function () { if (document.hidden) pauseOthers(null); });
  window.addEventListener('pagehide', function () { pauseOthers(null); });
  window.addEventListener('resize', function () { states.forEach(function (state) { state.resize(); }); }, {passive: true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiwabi-rv-media-base-prior-to-234-20261012"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var states = new Set();
  var idSequence = 0;

  function youtubeReady() {
    if (window.YT && typeof window.YT.Player === 'function') return Promise.resolve(window.YT);
    if (window.__rvcYouTubeReady) return window.__rvcYouTubeReady;
    window.__rvcYouTubeReady = new Promise(function (resolve) {
      var done = false;
      var previous = window.onYouTubeIframeAPIReady;
      function finish(api) { if (!done) { done = true; resolve(api); } }
      window.onYouTubeIframeAPIReady = function () {
        try { if (typeof previous === 'function') previous(); } catch (error) {}
        finish(window.YT || null);
      };
      if (!document.querySelector('script[src*="youtube.com/iframe_api"],script[src*="youtube.com/player_api"]')) {
        var script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.onerror = function () { finish(null); };
        document.head.appendChild(script);
      }
      window.setTimeout(function () { finish(window.YT || null); }, 15000);
    });
    return window.__rvcYouTubeReady;
  }

  function plainText(element) {
    if (!element) return '';
    var copy = element.cloneNode(true);
    copy.querySelectorAll('script,style,iframe,button').forEach(function (node) { node.remove(); });
    copy.querySelectorAll('br').forEach(function (node) { node.replaceWith(document.createTextNode('\n')); });
    copy.querySelectorAll('p').forEach(function (node) { node.appendChild(document.createTextNode('\n')); });
    return copy.textContent.trim();
  }

  function fillReviews(card) {
    var source = card.querySelector('template[data-rvc-review-source]');
    var list = card.querySelector('[data-rvc-review-list]');
    if (!source || !list) return;
    var fragment = document.createDocumentFragment();
    var seen = new Set();
    var count = 0;
    source.content.querySelectorAll('.jdgm-rev[data-review-id]').forEach(function (review) {
      if (count >= 5) return;
      var id = review.getAttribute('data-review-id');
      if (!id || seen.has(id)) return;
      var productUrl = review.getAttribute('data-product-url');
      if (productUrl) {
        try {
          var handle = new URL(productUrl, window.location.origin).pathname.split('/').filter(Boolean).pop();
          if (handle !== card.dataset.productHandle) return;
        } catch (error) { return; }
      }
      var body = plainText(review.querySelector('.jdgm-rev__body'));
      var title = plainText(review.querySelector('.jdgm-rev__title'));
      var scoreNode = review.querySelector('.jdgm-rev__rating');
      var score = Number(scoreNode && scoreNode.getAttribute('data-score'));
      if (!body || !Number.isFinite(score) || score < 1 || score > 5) return;
      seen.add(id);
      var item = document.createElement('article');
      item.className = 'rvc-mob-review-item';
      item.dataset.reviewId = id;
      var meta = document.createElement('div');
      meta.className = 'rvc-mob-review-meta';
      var stars = document.createElement('span');
      stars.className = 'rvc-mob-review-stars';
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', '5点満点中' + score + '点');
      stars.textContent = '★'.repeat(Math.round(score)) + '☆'.repeat(5 - Math.round(score));
      meta.appendChild(stars);
      var dateNode = review.querySelector('.jdgm-rev__timestamp');
      var date = dateNode && dateNode.getAttribute('datetime');
      if (date && /^\d{4}-\d{2}-\d{2}/.test(date)) {
        var time = document.createElement('time');
        time.dateTime = date;
        time.textContent = date.slice(0, 10).replace(/-/g, '.');
        meta.appendChild(time);
      }
      item.appendChild(meta);
      if (title) { var heading = document.createElement('h4'); heading.textContent = title; item.appendChild(heading); }
      var paragraph = document.createElement('p');
      paragraph.className = 'rvc-mob-review-body';
      paragraph.textContent = body;
      item.appendChild(paragraph);
      fragment.appendChild(item);
      count += 1;
    });
    if (count) {
      list.replaceChildren(fragment);
      list.setAttribute('aria-label', count + '件の公開レビュー。上下にスクロールして読めます。');
      var hint = card.querySelector('[data-rvc-review-hint]');
      if (hint) hint.textContent = count + '件・下へスクロール ↓';
      card.dataset.rvcVisibleReviews = String(count);
    }
  }

  function pauseOthers(active) {
    states.forEach(function (state) { if (state !== active) state.pause(); });
  }

  function prepare(card) {
    if (card.dataset.rvcSwipeReady === 'v3') return;
    var track = card.querySelector('[data-rvc-track]');
    var slides = Array.from(card.querySelectorAll('[data-rvc-slide]'));
    var buttons = Array.from(card.querySelectorAll('[data-rvc-go]'));
    if (!track || slides.length < 2 || buttons.length !== slides.length) return;
    var frame = card.querySelector('iframe[data-rvc-video-src]');
    var nativeVideo = card.querySelector('video');
    var videoIndex = slides.findIndex(function (slide) { return slide.classList.contains('rvc-mob-slide--video'); });
    var current = 0;
    var player = null;
    var observer = null;
    var playerRequested = false;
    var scheduled = false;
    var destroyed = false;
    card.dataset.rvcSwipeReady = 'v3';
    fillReviews(card);

    function pause() {
      if (nativeVideo) { try { nativeVideo.pause(); } catch (error) {} }
      if (player && typeof player.pauseVideo === 'function') {
        try { player.pauseVideo(); } catch (error) {}
      } else if (frame && frame.getAttribute('src') && frame.contentWindow) {
        try {
          var origin = new URL(frame.src).origin;
          var command = frame.dataset.rvcVideoHost === 'vimeo' ? {method: 'pause'} : {event: 'command', func: 'pauseVideo', args: []};
          frame.contentWindow.postMessage(JSON.stringify(command), origin);
        } catch (error) {}
      }
    }

    function loadVideo() {
      if (!track.clientWidth || current !== videoIndex || !frame || destroyed) return;
      if (!frame.getAttribute('src')) {
        try {
          var url = new URL(frame.dataset.rvcVideoSrc, window.location.origin);
          if (url.protocol !== 'https:' || !['www.youtube.com','www.youtube-nocookie.com','player.vimeo.com'].includes(url.hostname)) return;
          url.searchParams.set('autoplay', '0');
          url.searchParams.set('playsinline', '1');
          if (frame.dataset.rvcVideoHost === 'youtube') {
            url.searchParams.set('enablejsapi', '1');
            url.searchParams.set('origin', window.location.origin);
          }
          frame.id = 'rvc-product-video-' + (++idSequence);
          frame.src = url.href;
        } catch (error) { return; }
      }
      if (frame.dataset.rvcVideoHost === 'youtube' && !playerRequested) {
        playerRequested = true;
        youtubeReady().then(function (api) {
          if (destroyed || !card.isConnected || !api || typeof api.Player !== 'function') return;
          try {
            player = new api.Player(frame, {events: {
              onReady: function () { if (!track.clientWidth || current !== videoIndex) pause(); },
              onStateChange: function (event) {
                if (event.data === 1) {
                  if (!track.clientWidth || current !== videoIndex || document.hidden) pause();
                  else pauseOthers(state);
                }
              }
            }});
          } catch (error) { player = null; }
        });
      }
    }

    function select(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      if (index !== current) {
        pause();
        current = index;
        if (current === videoIndex) pauseOthers(state);
      }
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !active;
      });
      buttons.forEach(function (button, i) {
        button.classList.toggle('is-active', i === current);
        button.setAttribute('aria-pressed', i === current ? 'true' : 'false');
      });
      loadVideo();
    }
    function sync() {
      scheduled = false;
      if (track.clientWidth) select(Math.round(track.scrollLeft / track.clientWidth));
    }
    function scrollHandler() {
      if (!scheduled) { scheduled = true; window.requestAnimationFrame(sync); }
    }
    track.addEventListener('scroll', scrollHandler, {passive: true});
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = Number(button.dataset.rvcGo);
        if (!Number.isInteger(index) || !slides[index]) return;
        select(index);
        track.scrollTo({left: index * track.clientWidth, behavior: 'auto'});
      });
    });
    var navigation = card.querySelector('.rvc-mob-pagination');
    function keyHandler(event) {
      var focused = buttons.indexOf(event.target);
      if (focused < 0) return;
      var target = focused;
      if (event.key === 'ArrowRight') target = (focused + 1) % buttons.length;
      else if (event.key === 'ArrowLeft') target = (focused + buttons.length - 1) % buttons.length;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = buttons.length - 1;
      else return;
      event.preventDefault();
      buttons[target].focus({preventScroll: true});
      buttons[target].click();
    }
    if (navigation) navigation.addEventListener('keydown', keyHandler);
    var state = {
      card: card,
      pause: pause,
      resize: function () {
        if (!track.clientWidth) pause();
        else if (track.clientWidth) { track.scrollTo({left: current * track.clientWidth, behavior: 'auto'}); select(current); }
      },
      destroy: function () {
        destroyed = true; pause();
        if (observer) observer.disconnect();
        if (player && player.destroy) { try { player.destroy(); } catch (error) {} }
        track.removeEventListener('scroll', scrollHandler);
        if (navigation) navigation.removeEventListener('keydown', keyHandler);
        states.delete(state);
      }
    };
    states.add(state);
    if (nativeVideo) nativeVideo.addEventListener('play', function () { pauseOthers(state); });
    var videoSurface = card.querySelector('.rvc-mob-video-player');
    if (videoSurface && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].intersectionRatio < 0.15) pause();
      }, {threshold: [0, 0.15]});
      observer.observe(videoSurface);
    }
    select(0);
  }

  function initialize() {
    states.forEach(function (state) { if (!state.card.isConnected) state.destroy(); });
    document.querySelectorAll('#rv-comparison [data-rvc-mobile-card]').forEach(prepare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', function (event) {
    states.forEach(function (state) { if (event.target.contains(state.card)) state.destroy(); });
  });
  document.addEventListener('visibilitychange', function () { if (document.hidden) pauseOthers(null); });
  window.addEventListener('pagehide', function () { pauseOthers(null); });
  window.addEventListener('resize', function () { states.forEach(function (state) { state.resize(); }); }, {passive: true});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiwabi-rv-media-pre-fullframe-20261012"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var states = new Set();
  var idSequence = 0;

  function youtubeReady() {
    if (window.YT && typeof window.YT.Player === 'function') return Promise.resolve(window.YT);
    if (window.__rvcYouTubeReady) return window.__rvcYouTubeReady;
    window.__rvcYouTubeReady = new Promise(function (resolve) {
      var done = false;
      var previous = window.onYouTubeIframeAPIReady;
      function finish(api) { if (!done) { done = true; resolve(api); } }
      window.onYouTubeIframeAPIReady = function () {
        try { if (typeof previous === 'function') previous(); } catch (error) {}
        finish(window.YT || null);
      };
      if (!document.querySelector('script[src*="youtube.com/iframe_api"],script[src*="youtube.com/player_api"]')) {
        var script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.onerror = function () { finish(null); };
        document.head.appendChild(script);
      }
      window.setTimeout(function () { finish(window.YT || null); }, 15000);
    });
    return window.__rvcYouTubeReady;
  }

  function plainText(element) {
    if (!element) return '';
    var copy = element.cloneNode(true);
    copy.querySelectorAll('script,style,iframe,button').forEach(function (node) { node.remove(); });
    copy.querySelectorAll('br').forEach(function (node) { node.replaceWith(document.createTextNode('\n')); });
    copy.querySelectorAll('p').forEach(function (node) { node.appendChild(document.createTextNode('\n')); });
    return copy.textContent.trim();
  }

  function fillReviews(card) {
    var source = card.querySelector('template[data-rvc-review-source]');
    var list = card.querySelector('[data-rvc-review-list]');
    if (!source || !list) return;
    var fragment = document.createDocumentFragment();
    var seen = new Set();
    var count = 0;
    source.content.querySelectorAll('.jdgm-rev[data-review-id]').forEach(function (review) {
      if (count >= 5) return;
      var id = review.getAttribute('data-review-id');
      if (!id || seen.has(id)) return;
      var productUrl = review.getAttribute('data-product-url');
      if (productUrl) {
        try {
          var handle = new URL(productUrl, window.location.origin).pathname.split('/').filter(Boolean).pop();
          if (handle !== card.dataset.productHandle) return;
        } catch (error) { return; }
      }
      var body = plainText(review.querySelector('.jdgm-rev__body'));
      var title = plainText(review.querySelector('.jdgm-rev__title'));
      var scoreNode = review.querySelector('.jdgm-rev__rating');
      var score = Number(scoreNode && scoreNode.getAttribute('data-score'));
      if (!body || !Number.isFinite(score) || score < 1 || score > 5) return;
      seen.add(id);
      var item = document.createElement('article');
      item.className = 'rvc-mob-review-item';
      item.dataset.reviewId = id;
      var meta = document.createElement('div');
      meta.className = 'rvc-mob-review-meta';
      var stars = document.createElement('span');
      stars.className = 'rvc-mob-review-stars';
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', '5点満点中' + score + '点');
      stars.textContent = '★'.repeat(Math.round(score)) + '☆'.repeat(5 - Math.round(score));
      meta.appendChild(stars);
      var dateNode = review.querySelector('.jdgm-rev__timestamp');
      var date = dateNode && dateNode.getAttribute('datetime');
      if (date && /^\d{4}-\d{2}-\d{2}/.test(date)) {
        var time = document.createElement('time');
        time.dateTime = date;
        time.textContent = date.slice(0, 10).replace(/-/g, '.');
        meta.appendChild(time);
      }
      item.appendChild(meta);
      if (title) { var heading = document.createElement('h4'); heading.textContent = title; item.appendChild(heading); }
      var paragraph = document.createElement('p');
      paragraph.className = 'rvc-mob-review-body';
      paragraph.textContent = body;
      item.appendChild(paragraph);
      fragment.appendChild(item);
      count += 1;
    });
    if (count) {
      list.replaceChildren(fragment);
      list.setAttribute('aria-label', count + '件の公開レビュー。上下にスクロールして読めます。');
      var hint = card.querySelector('[data-rvc-review-hint]');
      if (hint) hint.textContent = count + '件・下へスクロール ↓';
      card.dataset.rvcVisibleReviews = String(count);
    }
  }

  function pauseOthers(active) {
    states.forEach(function (state) { if (state !== active) state.pause(); });
  }

  function prepare(card) {
    if (card.dataset.rvcSwipeReady === 'v3') return;
    var track = card.querySelector('[data-rvc-track]');
    var slides = Array.from(card.querySelectorAll('[data-rvc-slide]'));
    var buttons = Array.from(card.querySelectorAll('[data-rvc-go]'));
    if (!track || slides.length < 2 || buttons.length !== slides.length) return;
    var frame = card.querySelector('iframe[data-rvc-video-src]');
    var nativeVideo = card.querySelector('video');
    var videoIndex = slides.findIndex(function (slide) { return slide.classList.contains('rvc-mob-slide--video'); });
    var current = 0;
    var player = null;
    var observer = null;
    var playerRequested = false;
    var scheduled = false;
    var destroyed = false;
    card.dataset.rvcSwipeReady = 'v3';
    fillReviews(card);

    function pause() {
      if (nativeVideo) { try { nativeVideo.pause(); } catch (error) {} }
      if (player && typeof player.pauseVideo === 'function') {
        try { player.pauseVideo(); } catch (error) {}
      } else if (frame && frame.getAttribute('src') && frame.contentWindow) {
        try {
          var origin = new URL(frame.src).origin;
          var command = frame.dataset.rvcVideoHost === 'vimeo' ? {method: 'pause'} : {event: 'command', func: 'pauseVideo', args: []};
          frame.contentWindow.postMessage(JSON.stringify(command), origin);
        } catch (error) {}
      }
    }

    function loadVideo() {
      if (!track.clientWidth || current !== videoIndex || !frame || destroyed) return;
      if (!frame.getAttribute('src')) {
        try {
          var url = new URL(frame.dataset.rvcVideoSrc, window.location.origin);
          if (url.protocol !== 'https:' || !['www.youtube.com','www.youtube-nocookie.com','player.vimeo.com'].includes(url.hostname)) return;
          url.searchParams.set('autoplay', '0');
          url.searchParams.set('playsinline', '1');
          if (frame.dataset.rvcVideoHost === 'youtube') {
            url.searchParams.set('enablejsapi', '1');
            url.searchParams.set('origin', window.location.origin);
          }
          frame.id = 'rvc-product-video-' + (++idSequence);
          frame.src = url.href;
        } catch (error) { return; }
      }
      if (frame.dataset.rvcVideoHost === 'youtube' && !playerRequested) {
        playerRequested = true;
        youtubeReady().then(function (api) {
          if (destroyed || !card.isConnected || !api || typeof api.Player !== 'function') return;
          try {
            player = new api.Player(frame, {events: {
              onReady: function () { if (!track.clientWidth || current !== videoIndex) pause(); },
              onStateChange: function (event) {
                if (event.data === 1) {
                  if (!track.clientWidth || current !== videoIndex || document.hidden) pause();
                  else pauseOthers(state);
                }
              }
            }});
          } catch (error) { player = null; }
        });
      }
    }

    function select(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      if (index !== current) {
        pause();
        current = index;
        if (current === videoIndex) pauseOthers(state);
      }
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !active;
      });
      buttons.forEach(function (button, i) {
        button.classList.toggle('is-active', i === current);
        button.setAttribute('aria-pressed', i === current ? 'true' : 'false');
      });
      loadVideo();
    }
    function sync() {
      scheduled = false;
      if (track.clientWidth) select(Math.round(track.scrollLeft / track.clientWidth));
    }
    function scrollHandler() {
      if (!scheduled) { scheduled = true; window.requestAnimationFrame(sync); }
    }
    track.addEventListener('scroll', scrollHandler, {passive: true});
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = Number(button.dataset.rvcGo);
        if (!Number.isInteger(index) || !slides[index]) return;
        select(index);
        track.scrollTo({left: index * track.clientWidth, behavior: 'auto'});
      });
    });
    var navigation = card.querySelector('.rvc-mob-pagination');
    function keyHandler(event) {
      var focused = buttons.indexOf(event.target);
      if (focused < 0) return;
      var target = focused;
      if (event.key === 'ArrowRight') target = (focused + 1) % buttons.length;
      else if (event.key === 'ArrowLeft') target = (focused + buttons.length - 1) % buttons.length;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = buttons.length - 1;
      else return;
      event.preventDefault();
      buttons[target].focus({preventScroll: true});
      buttons[target].click();
    }
    if (navigation) navigation.addEventListener('keydown', keyHandler);
    var state = {
      card: card,
      pause: pause,
      resize: function () {
        if (!track.clientWidth) pause();
        else if (track.clientWidth) { track.scrollTo({left: current * track.clientWidth, behavior: 'auto'}); select(current); }
      },
      destroy: function () {
        destroyed = true; pause();
        if (observer) observer.disconnect();
        if (player && player.destroy) { try { player.destroy(); } catch (error) {} }
        track.removeEventListener('scroll', scrollHandler);
        if (navigation) navigation.removeEventListener('keydown', keyHandler);
        states.delete(state);
      }
    };
    states.add(state);
    if (nativeVideo) nativeVideo.addEventListener('play', function () { pauseOthers(state); });
    var videoSurface = card.querySelector('.rvc-mob-video-player');
    if (videoSurface && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].intersectionRatio < 0.15) pause();
      }, {threshold: [0, 0.15]});
      observer.observe(videoSurface);
    }
    select(0);
  }

  function initialize() {
    states.forEach(function (state) { if (!state.card.isConnected) state.destroy(); });
    document.querySelectorAll('#rv-comparison [data-rvc-mobile-card]').forEach(prepare);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', function (event) {
    states.forEach(function (state) { if (event.target.contains(state.card)) state.destroy(); });
  });
  document.addEventListener('visibilitychange', function () { if (document.hidden) pauseOthers(null); });
  window.addEventListener('pagehide', function () { pauseOthers(null); });
  window.addEventListener('resize', function () { states.forEach(function (state) { state.resize(); }); }, {passive: true});
})();
  } catch(e) { console.error(e); }
})();

})();
